// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-25 21:36:23

export default {
  "id": "color-nuts-and-bolts-puzzle",
  "slug": "color-nuts-and-bolts-puzzle",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/0a13230dcbc049188f48c7d985420618-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/0a13230dcbc049188f48c7d985420618/",
  "releaseDate": "2025-03-25",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Color Nuts & Bolts Puzzle",
      "description": "Color Nuts & Bolts Puzzle is a fun and engaging puzzle game that challenges your spatial imagination and color-matching skills! Match colorful screws to their corresponding nuts and watch as your puzzle-solving skills bring vibrant images to life. Perfect for players of all ages, this game offers hours of brain-teasing fun with a visually satisfying reward at the end of each challenge. Test your logic, precision, and creativity in this unique puzzle-solving adventure!",
      "instructions": "Objective: Match the colored screws to their corresponding nuts on the board.\n\nHow to Play:\n1) Drag and drop screws to the nuts of the same color.\n2) Ensure the screws fit correctly without overlapping or blocking other screws.\n\nChallenge Mode: Solve a series of puzzles to reveal a complete picture!\n\nWin Condition: Complete the puzzle by successfully matching all screws to their nuts.",
      "genres": [
        "Casual",
        "Puzzle"
      ],
      "tags": [
        "1player",
        "2d",
        "clicker",
        "color",
        "colormatch"
      ]
    },
    "zh-CN": {
      "title": "色彩螺丝钉拼图",
      "description": "《彩色螺丝螺母拼图》是一款有趣且引人入胜的益智游戏，挑战你的空间想象力和颜色匹配技巧！将彩色螺丝与相应的螺母匹配，看着你的解谜技巧让鲜艳的图像栩栩如生。适合所有年龄段的玩家，这款游戏提供了数小时的脑力挑战乐趣，并在每个挑战结束时带来视觉上的满足感。在这场独特的解谜冒险中，测试你的逻辑、精准度和创造力吧！",
      "instructions": "目标：将彩色螺丝与棋盘上对应的螺母相匹配。\n\n玩法：\n1）拖放螺丝到相同颜色的螺母上。\n2）确保螺丝正确适配，不重叠或阻挡其他螺丝。\n\n挑战模式：解决一系列谜题，揭示完整图片！\n\n胜利条件：成功将所有螺丝与螺母匹配，完成拼图。",
      "genres": [
        "休闲",
        "益智"
      ],
      "tags": [
        "1玩家",
        "2D",
        "点击",
        "颜色",
        "颜色匹配"
      ]
    },
    "zh-TW": {
      "title": "彩色螺帽螺栓拼圖",
      "description": "色彩螺帽螺絲釘拼圖是一款有趣且引人入勝的益智遊戲，挑戰你的空間想像力和色彩配對技巧！將彩色螺絲釘與其對應的螺帽相匹配，觀看你解謎技巧如何讓鮮豔的圖像栩栩如生。適合所有年齡段的玩家，這款遊戲提供數小時的腦力激盪樂趣，並在每個挑戰結束時帶來視覺上的滿足感。在這場獨特的解謎冒險中，測試你的邏輯、精準度和創造力吧！",
      "instructions": "目標：將彩色螺絲與板上對應的螺帽配對。\n\n遊戲玩法：\n1. 拖曳螺絲至相同顏色的螺帽上。\n2. 確保螺絲正確無誤地匹配，避免相互重疊或阻礙。\n\n挑戰模式：通過\n**目標**：\n- 將經過優化的文本進行精確翻譯，確保翻譯結果符合繁體中文的語言習慣。\n- 維持原文的清晰與簡潔風格。\n\n### 翻譯過程\n\n1. **理解原文**：\n   - 原文是一個數學問題，要求解一個由0開\n**目標**：\n- 根據用戶提供的內容，進行準確且符合要求的翻譯。\n- 確保翻譯結果自然、流暢，並符合繁體中文的語言習\",\n        \"属性值\": \"金属\"\n    },\n    {\n        \"属性名\": \"工艺\",\n        \"属性值\": \"精漆\"\n    },\n    {\n        \"属性名\": \"用途\",\n        \"属性值\": \"户外\"\n    },\n\n，轻巧便携，适合多种场合使用\"\n}",
      "genres": [
        "休閒",
        "益智"
      ],
      "tags": [
        "1位玩家",
        "2D",
        "點擊遊戲",
        "顏色",
        "顏色匹配"
      ]
    },
    "zh-HK": {
      "title": "色彩螺帽螺栓拼圖",
      "description": "色彩螺帽螺栓拼圖是一款有趣且引人入勝的拼圖遊戲，挑戰你的空間想像力和色彩配對技巧！將彩色螺絲釘與其對應的螺帽配對，並觀看你的解謎技巧如何讓鮮豔的圖像栩栩如生。適合所有年齡層的玩家，這款遊戲提供數小時的腦筋急轉彎樂趣，並在每個挑戰結束時帶來視覺上的滿足感。在這場獨特的解謎冒險中，測試你的邏輯、精準度和創造力！",
      "instructions": "目標：將彩色螺絲與板上對應的螺母配對。\n\n遊戲玩法：\n1) 拖放螺絲至相同顏色的螺母上。\n2) 確保螺絲正確配合，不得重疊或阻礙其他螺絲。\n\n挑戰模式：解開一系列謎題，揭示完整圖片！\n\n勝利條件：成功將所有螺絲與螺母配對，完成謎題。",
      "genres": [
        "休閒",
        "益智"
      ],
      "tags": [
        "1位玩家",
        "2D",
        "點擊遊戲",
        "顏色",
        "顏色配對"
      ]
    },
    "ja": {
      "title": "カラーナッツ＆ボルトパズル",
      "description": "カラフル・ナッツ＆ボルト・パズルは、空間想象力と色合わせスキルに挑戦する楽しくて引き込まれるパズルゲームです！カラフルなネジを対応するナットと合わせて、パズル解決スキルで鮮やかなイメージを生き生きとさせてください。すべての年齢層のプレイヤーに最適で、このゲームは各チャレンジの終わりに視覚的に満足する報酬を提供する頭脳 teaser の楽しさを何時間も提供します。このユニークなパズル解決アドベンチャーで、論理、精度、そして創造性をテストしてください！",
      "instructions": "目標: ボード上の色と一致するナットに色付きのネジを合わせる。\n\n遊び方:\n1) 同じ色のナットにネジをドラッグ＆ドロップします。\n2) ネジが正しくフィットし、他のネジと重ならないようにします。\n\nチャレンジモード: 一連のパズルを解いて、完全な画像を明らかにしよう！\n\n勝利条件: すべてのネジを正しくナットに合わせてパズルを完成させる。",
      "genres": [
        "カジュアル",
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "2D",
        "クリッカー",
        "カラー",
        "カラーマッチ"
      ]
    },
    "ko": {
      "title": "컬러 너츠 앤 볼츠 퍼즐",
      "description": "\"Color Nuts & Bolts Puzzle\"은 공간 상상력과 색상 매칭 기술을 도전하는 재미있고 몰입감 있는 퍼즐 게임입니다! 다채로운 나사를 해당하는 너트와 일치시키고, 퍼즐 해결 능력이 생동감 넘치는 이미지를 불러오는 것을 지켜보세요. 모든 연령대의 플레이어에게 적합한 이 게임은 각 도전의 끝에 시각적으로 만족스러운 보상을 제공하는 시간 가는 뇌 퍼즐 재미를 제공합니다. 이 독특한 퍼즐 해결 모험에서 논리, 정밀도, 창의력을 시험해 보세요!",
      "instructions": "목표: 보드 위의 같은 색상의 너트에 맞는 컬러 스크루를 맞추세요.\n\n게임 방법:\n1) 스크루를 드래그하여 같은 색상의 너트에 놓으세요.\n2) 스크루가 올바르게 맞물리도록 하고, 다른 스크루를 가리거나 겹치지 않도록 하세요.\n\n챌린지 모드: 일련의 퍼즐을 풀어 완전한 이미지를 드러내세요!\n\n승리 조건: 모든 스크루를 너트에 성공적으로 맞추어 퍼즐을 완성하세요.",
      "genres": [
        "캐주얼",
        "퍼즐"
      ],
      "tags": [
        "1인용",
        "2D",
        "클리커",
        "색상",
        "색상매칭"
      ]
    },
    "fr": {
      "title": "Puzzle à Nuts & Bolts en Couleur",
      "description": "Color Nuts & Bolts Puzzle est un jeu de puzzle amusant et captivant qui défie votre imagination spatiale et vos compétences en correspondance des couleurs ! Faites correspondre les vis colorées à leurs écrous correspondants et regardez vos compétences en résolution de puzzles animer des images vibrantes. Parfait pour les joueurs de tous âges, ce jeu offre des heures de plaisir cérébral avec une récompense visuellement satisfaisante à la fin de chaque défi. Testez votre logique, votre précision et votre créativité dans cette aventure unique de résolution de puzzles !",
      "instructions": "Objectif : Faire correspondre les vis colorées à leurs écrous correspondants sur le plateau.\n\nComment jouer :\n1) Glissez-déposez les vis sur les écrous de la même couleur.\n2) Assurez-vous que les vis s'ajustent correctement sans se chevaucher ni bloquer d'autres vis.\n\nMode Défi : Résolvez une série de puzzles pour révéler une image complète !\n\nCondition de victoire : Terminez le puzzle en faisant correspondre avec succès toutes les vis à leurs écrous.",
      "genres": [
        "Décontracté",
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "2D",
        "cliquer",
        "couleur",
        "correspondance de couleurs"
      ]
    }
  }
};
